/**
 * Generated by orval v7.18.0 🍺
 * Do not edit manually.
 * NXT48
 * API documentation generated from Zod schemas
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  MetatagsCreate200,
  MetatagsCreate400,
  MetatagsCreateBody,
  MetatagsDelete200,
  MetatagsDelete400,
  MetatagsGetActive200Item,
  MetatagsGetActive400,
  MetatagsGetAll200,
  MetatagsGetAll400,
  MetatagsGetAllParams,
  MetatagsGetById200,
  MetatagsGetById400,
  MetatagsUpdate200,
  MetatagsUpdate400,
  MetatagsUpdateBody
} from '../nxt48.schemas';

import { customInstance } from '../../orval-fetcher';




/**
 * Get all meta tags with pagination
 * @summary List Meta Tags
 */
export const metatagsGetAll = (
    params?: MetatagsGetAllParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<MetatagsGetAll200>(
      {url: `/meta-tags`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getMetatagsGetAllQueryKey = (params?: MetatagsGetAllParams,) => {
    return [
    `/meta-tags`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getMetatagsGetAllQueryOptions = <TData = Awaited<ReturnType<typeof metatagsGetAll>>, TError = MetatagsGetAll400 | void>(params?: MetatagsGetAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metatagsGetAll>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMetatagsGetAllQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof metatagsGetAll>>> = ({ signal }) => metatagsGetAll(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof metatagsGetAll>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type MetatagsGetAllQueryResult = NonNullable<Awaited<ReturnType<typeof metatagsGetAll>>>
export type MetatagsGetAllQueryError = MetatagsGetAll400 | void


export function useMetatagsGetAll<TData = Awaited<ReturnType<typeof metatagsGetAll>>, TError = MetatagsGetAll400 | void>(
 params: undefined |  MetatagsGetAllParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof metatagsGetAll>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof metatagsGetAll>>,
          TError,
          Awaited<ReturnType<typeof metatagsGetAll>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useMetatagsGetAll<TData = Awaited<ReturnType<typeof metatagsGetAll>>, TError = MetatagsGetAll400 | void>(
 params?: MetatagsGetAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metatagsGetAll>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof metatagsGetAll>>,
          TError,
          Awaited<ReturnType<typeof metatagsGetAll>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useMetatagsGetAll<TData = Awaited<ReturnType<typeof metatagsGetAll>>, TError = MetatagsGetAll400 | void>(
 params?: MetatagsGetAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metatagsGetAll>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List Meta Tags
 */

export function useMetatagsGetAll<TData = Awaited<ReturnType<typeof metatagsGetAll>>, TError = MetatagsGetAll400 | void>(
 params?: MetatagsGetAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metatagsGetAll>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getMetatagsGetAllQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create a new meta tag
 * @summary Create Meta Tag
 */
export const metatagsCreate = (
    metatagsCreateBody: MetatagsCreateBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<MetatagsCreate200>(
      {url: `/meta-tags`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: metatagsCreateBody, signal
    },
      );
    }
  


export const getMetatagsCreateMutationOptions = <TError = MetatagsCreate400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof metatagsCreate>>, TError,{data: MetatagsCreateBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof metatagsCreate>>, TError,{data: MetatagsCreateBody}, TContext> => {

const mutationKey = ['metatagsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof metatagsCreate>>, {data: MetatagsCreateBody}> = (props) => {
          const {data} = props ?? {};

          return  metatagsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MetatagsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof metatagsCreate>>>
    export type MetatagsCreateMutationBody = MetatagsCreateBody
    export type MetatagsCreateMutationError = MetatagsCreate400 | void

    /**
 * @summary Create Meta Tag
 */
export const useMetatagsCreate = <TError = MetatagsCreate400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof metatagsCreate>>, TError,{data: MetatagsCreateBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof metatagsCreate>>,
        TError,
        {data: MetatagsCreateBody},
        TContext
      > => {

      const mutationOptions = getMetatagsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Get all active meta tags for SEO (public endpoint)
 * @summary Get Active Meta Tags
 */
export const metatagsGetActive = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<MetatagsGetActive200Item[]>(
      {url: `/meta-tags/active`, method: 'GET', signal
    },
      );
    }
  



export const getMetatagsGetActiveQueryKey = () => {
    return [
    `/meta-tags/active`
    ] as const;
    }

    
export const getMetatagsGetActiveQueryOptions = <TData = Awaited<ReturnType<typeof metatagsGetActive>>, TError = MetatagsGetActive400>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metatagsGetActive>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMetatagsGetActiveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof metatagsGetActive>>> = ({ signal }) => metatagsGetActive(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof metatagsGetActive>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type MetatagsGetActiveQueryResult = NonNullable<Awaited<ReturnType<typeof metatagsGetActive>>>
export type MetatagsGetActiveQueryError = MetatagsGetActive400


export function useMetatagsGetActive<TData = Awaited<ReturnType<typeof metatagsGetActive>>, TError = MetatagsGetActive400>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof metatagsGetActive>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof metatagsGetActive>>,
          TError,
          Awaited<ReturnType<typeof metatagsGetActive>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useMetatagsGetActive<TData = Awaited<ReturnType<typeof metatagsGetActive>>, TError = MetatagsGetActive400>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metatagsGetActive>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof metatagsGetActive>>,
          TError,
          Awaited<ReturnType<typeof metatagsGetActive>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useMetatagsGetActive<TData = Awaited<ReturnType<typeof metatagsGetActive>>, TError = MetatagsGetActive400>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metatagsGetActive>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Active Meta Tags
 */

export function useMetatagsGetActive<TData = Awaited<ReturnType<typeof metatagsGetActive>>, TError = MetatagsGetActive400>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metatagsGetActive>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getMetatagsGetActiveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get meta tag by ID
 * @summary Get Meta Tag
 */
export const metatagsGetById = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<MetatagsGetById200>(
      {url: `/meta-tags/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getMetatagsGetByIdQueryKey = (id?: string,) => {
    return [
    `/meta-tags/${id}`
    ] as const;
    }

    
export const getMetatagsGetByIdQueryOptions = <TData = Awaited<ReturnType<typeof metatagsGetById>>, TError = MetatagsGetById400 | void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metatagsGetById>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMetatagsGetByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof metatagsGetById>>> = ({ signal }) => metatagsGetById(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof metatagsGetById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type MetatagsGetByIdQueryResult = NonNullable<Awaited<ReturnType<typeof metatagsGetById>>>
export type MetatagsGetByIdQueryError = MetatagsGetById400 | void


export function useMetatagsGetById<TData = Awaited<ReturnType<typeof metatagsGetById>>, TError = MetatagsGetById400 | void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof metatagsGetById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof metatagsGetById>>,
          TError,
          Awaited<ReturnType<typeof metatagsGetById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useMetatagsGetById<TData = Awaited<ReturnType<typeof metatagsGetById>>, TError = MetatagsGetById400 | void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metatagsGetById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof metatagsGetById>>,
          TError,
          Awaited<ReturnType<typeof metatagsGetById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useMetatagsGetById<TData = Awaited<ReturnType<typeof metatagsGetById>>, TError = MetatagsGetById400 | void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metatagsGetById>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Meta Tag
 */

export function useMetatagsGetById<TData = Awaited<ReturnType<typeof metatagsGetById>>, TError = MetatagsGetById400 | void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metatagsGetById>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getMetatagsGetByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update meta tag by ID
 * @summary Update Meta Tag
 */
export const metatagsUpdate = (
    id: string,
    metatagsUpdateBody: MetatagsUpdateBody,
 ) => {
      
      
      return customInstance<MetatagsUpdate200>(
      {url: `/meta-tags/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: metatagsUpdateBody
    },
      );
    }
  


export const getMetatagsUpdateMutationOptions = <TError = MetatagsUpdate400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof metatagsUpdate>>, TError,{id: string;data: MetatagsUpdateBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof metatagsUpdate>>, TError,{id: string;data: MetatagsUpdateBody}, TContext> => {

const mutationKey = ['metatagsUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof metatagsUpdate>>, {id: string;data: MetatagsUpdateBody}> = (props) => {
          const {id,data} = props ?? {};

          return  metatagsUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MetatagsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof metatagsUpdate>>>
    export type MetatagsUpdateMutationBody = MetatagsUpdateBody
    export type MetatagsUpdateMutationError = MetatagsUpdate400 | void

    /**
 * @summary Update Meta Tag
 */
export const useMetatagsUpdate = <TError = MetatagsUpdate400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof metatagsUpdate>>, TError,{id: string;data: MetatagsUpdateBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof metatagsUpdate>>,
        TError,
        {id: string;data: MetatagsUpdateBody},
        TContext
      > => {

      const mutationOptions = getMetatagsUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Delete meta tag by ID
 * @summary Delete Meta Tag
 */
export const metatagsDelete = (
    id: string,
 ) => {
      
      
      return customInstance<MetatagsDelete200>(
      {url: `/meta-tags/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getMetatagsDeleteMutationOptions = <TError = MetatagsDelete400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof metatagsDelete>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof metatagsDelete>>, TError,{id: string}, TContext> => {

const mutationKey = ['metatagsDelete'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof metatagsDelete>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  metatagsDelete(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MetatagsDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof metatagsDelete>>>
    
    export type MetatagsDeleteMutationError = MetatagsDelete400 | void

    /**
 * @summary Delete Meta Tag
 */
export const useMetatagsDelete = <TError = MetatagsDelete400 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof metatagsDelete>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof metatagsDelete>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getMetatagsDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    